document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initBeforeAfter();
  initAccordion();
  initTicker();
  initProductGallery();
  initVariantPicker();
  initScrollTracks();
  initStickyCart();
  initVideoSlider();
  initLightbox();
});

function initLightbox() {
  var lightbox = document.querySelector('[data-lns-lightbox]');
  var mainWrap = document.querySelector('[data-lns-gallery-main-wrap]');
  if (!lightbox || !mainWrap) return;

  var lightboxImgs = lightbox.querySelectorAll('[data-lns-lightbox-img]');
  var total = lightboxImgs.length;
  var index = 0;
  var counterCurrent = lightbox.querySelector('[data-lns-lightbox-current]');

  function show(i) {
    index = (i + total) % total;
    lightboxImgs.forEach(function (img, n) {
      var active = n === index;
      img.style.display = active ? '' : 'none';
      img.classList.toggle('lns-active', active);
      if (img.tagName === 'VIDEO') {
        if (active && lightbox.classList.contains('lns-open')) {
          // opened by a real tap: play as a normal (non-muted) video so the browser
          // doesn't pause it like a background autoplay clip
          img.muted = false; img.removeAttribute('muted');
          var pp = img.play();
          if (pp && pp.catch) pp.catch(function () { img.muted = true; img.play().catch(function () {}); });
        }
        else img.pause();
      }
    });
    if (counterCurrent) counterCurrent.textContent = index + 1;
  }

  function open(startIndex) {
    lightbox.classList.add('lns-open');
    show(startIndex || 0);
    lightbox.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    lightboxImgs.forEach(function (el) { if (el.tagName === 'VIDEO') el.pause(); });
    lightbox.classList.remove('lns-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  mainWrap.addEventListener('click', function (e) {
    var img = e.target.closest('[data-lns-main-img]');
    if (!img) return;
    open(parseInt(img.getAttribute('data-index'), 10) || 0);
  });

  var closeBtn = lightbox.querySelector('[data-lns-lightbox-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) close();
  });

  var prevBtn = lightbox.querySelector('[data-lns-lightbox-prev]');
  var nextBtn = lightbox.querySelector('[data-lns-lightbox-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('lns-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(index - 1);
    if (e.key === 'ArrowRight') show(index + 1);
  });
}

function initVideoSlider() {
  var track = document.querySelector('.lns-video-track');
  if (!track) return;
  var videos = track.querySelectorAll('video');
  var index = 0;

  // Plays the video at `newIndex`, pauses every other one. Runs independently
  // of scroll position/visibility so the active slide is already playing the
  // moment the page loads, not only once the visitor scrolls this section
  // into view.
  function setActive(newIndex) {
    index = newIndex;
    videos.forEach(function (v, i) {
      if (i === newIndex) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }

  if (videos.length) {
    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
    });

    // Try right away — muted autoplay is allowed without a gesture in most
    // browsers, so this alone usually gets the first video playing instantly
    // on page load.
    setActive(0);

    // iOS Safari can still block unattended autoplay until the page has seen
    // at least one real user gesture — even for muted video. "Unlock" with a
    // quick play+pause the instant the visitor first taps/scrolls/clicks
    // anywhere on the page, then make sure the active slide keeps playing.
    function unlockVideos() {
      videos.forEach(function (v) {
        var p = v.play();
        if (p && p.then) {
          p.then(function () { if (v !== videos[index]) v.pause(); }).catch(function () {});
        }
      });
      setActive(index);
      document.removeEventListener('touchstart', unlockVideos);
      document.removeEventListener('click', unlockVideos);
      document.removeEventListener('scroll', unlockVideos);
    }
    document.addEventListener('touchstart', unlockVideos, { once: true, passive: true });
    document.addEventListener('click', unlockVideos, { once: true });
    document.addEventListener('scroll', unlockVideos, { once: true, passive: true });
  }

  var cards = track.querySelectorAll('.lns-video-card');

  // PetGlow: tap a video to play it (pauses the others and stops auto-rotation);
  // tap the playing one again to pause it.
  var userControl = false;
  cards.forEach(function (card, i) {
    card.style.cursor = 'pointer';
    card.addEventListener('click', function () {
      var v = videos[i];
      if (!v) return;
      userControl = true;
      stop();
      if (i === index && !v.paused) { v.pause(); return; }
      setActive(i);
      // real tap → play as a normal video so the browser never auto-pauses it
      v.muted = false; v.removeAttribute('muted');
      var pp = v.play();
      if (pp && pp.catch) pp.catch(function () { v.muted = true; v.play().catch(function () {}); });
    });
  });
  // show a ▶ badge on paused cards so visitors know they can tap them
  cards.forEach(function (card, i) {
    var v = videos[i]; if (!v) return;
    var sync = function () { card.classList.toggle('pg-is-paused', v.paused); };
    v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
  });
  // When the visitor swipes the row by hand, play the card that ends up in view.
  var swipeT = null;
  track.addEventListener('scroll', function () {
    if (!userControl) return;
    clearTimeout(swipeT);
    swipeT = setTimeout(function () {
      var tl = track.getBoundingClientRect().left, best = 0, bestD = 1e9;
      cards.forEach(function (c, i) { var d = Math.abs(c.getBoundingClientRect().left - tl); if (d < bestD) { bestD = d; best = i; } });
      if (best !== index && videos[best]) setActive(best);
    }, 150);
  }, { passive: true });
  track.addEventListener('touchstart', function () { userControl = true; stop(); }, { passive: true });
  var vwrap = track.parentElement;
  if (vwrap) vwrap.querySelectorAll('[data-lns-thumbs-prev],[data-lns-thumbs-next]').forEach(function (b) {
    b.addEventListener('click', function () { userControl = true; stop(); });
  });

  if (cards.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var timer = null;

  function goToNext() {
    var newIndex = (index + 1) % cards.length;
    var target = cards[newIndex];
    // Scroll only the horizontal track itself — never scrollIntoView, which
    // also drags the whole page vertically to reveal the element.
    track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    if (videos.length) {
      setActive(newIndex);
      // play again once the smooth scroll has brought the card fully into view
      setTimeout(function () { if (index === newIndex) setActive(newIndex); }, 700);
    }
  }

  function start() {
    stop();
    timer = setInterval(goToNext, 4000);
  }
  function stop() {
    if (timer) clearInterval(timer);
  }

  // Only auto-rotate while the slider is actually on screen.
  var visIo = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !userControl) { if (videos.length) setActive(index); start(); } else stop();
    });
  }, { threshold: 0.3 });
  visIo.observe(track);

  track.addEventListener('mouseenter', stop);
  track.addEventListener('mouseleave', function () {
    if (!userControl && track.getBoundingClientRect().top < window.innerHeight && track.getBoundingClientRect().bottom > 0) start();
  });
  track.addEventListener('touchstart', stop, { passive: true });
}

function initStickyCart() {
  var bar = document.querySelector('[data-lns-sticky-cart]');
  var realButton = document.querySelector('[data-lns-add-button]');
  if (!bar || !realButton) return;

  var stickyButton = bar.querySelector('[data-lns-sticky-add]');
  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      realButton.click();
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var pastButton = entry.boundingClientRect.top < 0;
      bar.classList.toggle('lns-visible', !entry.isIntersecting && pastButton);
    });
  }, { threshold: 0 });
  io.observe(realButton);
}

function initScrollTracks() {
  document.querySelectorAll('[data-lns-thumbs-track]').forEach(function (track) {
    var wrap = track.parentElement;
    if (!wrap) return;
    var prevBtn = wrap.querySelector('[data-lns-thumbs-prev]');
    var nextBtn = wrap.querySelector('[data-lns-thumbs-next]');
    function step() {
      var c = track.firstElementChild;
      if (!c) return 240;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return c.getBoundingClientRect().width + gap;
    }
    // Arrows loop: past the last card go back to the first, before the first jump to the last.
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 8; }
    function atStart() { return track.scrollLeft <= 8; }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (atStart()) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    // Swipe fallback: if a horizontal finger swipe didn't move the row natively, move it one card.
    var sx = 0, sy = 0, sl = 0;
    track.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; sl = track.scrollLeft; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 35 || Math.abs(dx) < Math.abs(dy)) return;
      setTimeout(function () {
        if (Math.abs(track.scrollLeft - sl) < 5) track.scrollBy({ left: dx < 0 ? step() : -step(), behavior: 'smooth' });
      }, 80);
    }, { passive: true });
  });
}

function initProductGallery() {
  var wraps = document.querySelectorAll('[data-lns-gallery-main-wrap]');
  wraps.forEach(function (wrap) {
    var mainImgs = wrap.querySelectorAll('[data-lns-main-img]');
    if (!mainImgs.length) return;
    var container = wrap.closest('.lns-product-gallery');
    var thumbs = container ? container.querySelectorAll('[data-lns-thumb]') : [];
    var prevBtn = wrap.querySelector('[data-lns-gallery-prev]');
    var nextBtn = wrap.querySelector('[data-lns-gallery-next]');
    var counterCurrent = wrap.querySelector('[data-lns-gallery-current]');
    var total = mainImgs.length;
    var current = 0;

    function show(index) {
      current = (index + total) % total;
      mainImgs.forEach(function (img, i) {
        img.classList.toggle('lns-active', i === current);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('lns-active', i === current);
      });
      if (counterCurrent) counterCurrent.textContent = current + 1;
      var activeThumb = thumbs[current];
      var thumbsTrack = container ? container.querySelector('.lns-product-thumbs') : null;
      // Scroll only the horizontal thumbnail strip — never scrollIntoView,
      // which can also drag the whole page vertically to reveal the element.
      if (activeThumb && thumbsTrack) {
        var targetLeft = activeThumb.offsetLeft - thumbsTrack.offsetLeft;
        thumbsTrack.scrollTo({ left: targetLeft, behavior: 'smooth' });
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });
  });
}

function initVariantPicker() {
  var forms = document.querySelectorAll('.lns-product-form');
  forms.forEach(function (form) {
    var variantsScript = form.querySelector('[data-lns-variants]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }
    var optionButtons = form.querySelectorAll('[data-lns-option-index]');
    var input = form.querySelector('[data-lns-variant-input]');
    var addButton = form.querySelector('[data-lns-add-button]');
    var addLabel = form.querySelector('[data-lns-add-label]');
    var priceEl = form.closest('.lns-product-buy') ? form.closest('.lns-product-buy').querySelector('.lns-product-price') : null;

    function currentSelection() {
      var selected = [];
      var groups = {};
      optionButtons.forEach(function (btn) {
        var idx = btn.getAttribute('data-lns-option-index');
        if (btn.classList.contains('lns-active')) groups[idx] = btn.getAttribute('data-lns-option-value');
      });
      var maxIndex = Math.max.apply(null, Object.keys(groups).map(Number).concat([0]));
      for (var i = 0; i <= maxIndex; i++) selected.push(groups[i]);
      return selected;
    }

    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return sel.every(function (s, i) { return s === undefined || s === v.options[i]; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      input.value = variant.id;
      if (priceEl && variant.priceFormatted) {
        priceEl.textContent = variant.priceFormatted;
      }
      var stickyPrice = document.querySelector('[data-lns-sticky-price]');
      if (stickyPrice && variant.priceFormatted) {
        stickyPrice.textContent = variant.priceFormatted;
      }
      if (variant.available) {
        addButton.removeAttribute('disabled');
        if (addLabel) addLabel.textContent = addButton.getAttribute('data-label-available');
      } else {
        addButton.setAttribute('disabled', 'disabled');
        if (addLabel) addLabel.textContent = addButton.getAttribute('data-label-sold-out');
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-lns-option-index');
        form.querySelectorAll('[data-lns-option-index="' + idx + '"]').forEach(function (b) {
          b.classList.remove('lns-active');
        });
        btn.classList.add('lns-active');
        updateUI();
      });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.lns-reveal, .lns-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('lns-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lns-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-lns-countup]');
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var target = parseFloat(el.getAttribute('data-lns-countup')) || 0;
      var suffix = el.getAttribute('data-lns-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target * eased;
        el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { io.observe(el); });
}

function initBeforeAfter() {
  var wraps = document.querySelectorAll('[data-lns-before-after]');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('.lns-ba-handle');
    var afterEl = wrap.querySelector('.lns-ba-after');
    if (!handle || !afterEl) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      var pct = (x / rect.width) * 100;
      afterEl.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    // Drag from anywhere on the image; vertical swipes still scroll the page.
    wrap.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (e.pointerType === 'mouse') setPos(e.clientX);
      try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) {
      wrap.addEventListener(ev, function () { dragging = false; });
    });
  });
}

function initAccordion() {
  var items = document.querySelectorAll('.lns-faq-item');
  items.forEach(function (item) {
    var btn = item.querySelector('.lns-faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('lns-open');
      item.closest('.lns-faq-list').querySelectorAll('.lns-faq-item').forEach(function (i) {
        i.classList.remove('lns-open');
      });
      if (!isOpen) item.classList.add('lns-open');
    });
  });
}

function initTicker() {
  var tickers = document.querySelectorAll('[data-lns-ticker]');
  tickers.forEach(function (t) {
    var track = t.querySelector('.lns-ticker-track');
    if (!track) return;
    track.innerHTML += track.innerHTML;
  });
}

/* PetGlow: show best-rated reviews first in the Judge.me widget */
(function(){
  var tries = 0;
  function pgSort(){
    var s = document.querySelector('select.jdgm-sort-dropdown');
    if(!s){ if(++tries < 40) setTimeout(pgSort, 500); return; }
    if(s.dataset.pgSorted) return;
    s.dataset.pgSorted = '1';
    if(s.value !== 'highest_rating'){
      s.value = 'highest_rating';
      s.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pgSort); else pgSort();
})();

/* PetGlow: links "#pg-all-reviews" scroll to the Judge.me reviews widget */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href="#pg-all-reviews"]');
  if (!a) return;
  var t = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
  if (!t) return;
  e.preventDefault();
  var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
  window.scrollTo({ top: y, behavior: 'smooth' });
});

/* PetGlow: "#pg-buy" links scroll smoothly to the bundle selector / buy box */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href="#pg-buy"]');
  if (!a) return;
  var t = document.querySelector('[data-lns-pack-list]') || document.getElementById('pg-buy');
  if (!t) return;
  e.preventDefault();
  window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
  t.classList.remove('pg-pulse'); void t.offsetWidth; t.classList.add('pg-pulse');
});
